/**
 * Hop note-field catalog. Defaults sniffed from Task Details System
 * (Chrome Web Store + gitlab.com/hop-studios/hop-browser-extensions/task-details-system
 * content.js config.fields). Maater allowlist extras stay available to Add field.
 */

export type NoteFieldKind = 'enum' | 'text' | 'tags'

export type NoteFieldDef = {
  key: string
  label: string
  kind: NoteFieldKind
  options?: readonly string[]
  /** Shown first in Add field (TDS create/edit form). */
  tdsDefault?: boolean
}

/** TDS `config.fields` + free-text rows from the TDS form. */
export const TDS_STATUS = [
  'not-started',
  'in-progress',
  'blocked',
  'waiting-for-input',
  'ready-for-review',
  'completed',
] as const

export const TDS_PRIORITY = ['critical', 'high', 'medium', 'low'] as const

export const TDS_CATEGORY = [
  'analytics',
  'development',
  'design',
  'content',
  'security',
  'marketing',
  'research',
] as const

export const TDS_COMPLEXITY = ['simple', 'medium', 'complex'] as const

const MAATER_CATEGORY_EXTRA = ['infrastructure', 'seo', 'compliance'] as const

export const NOTE_FIELD_CATALOG: NoteFieldDef[] = [
  { key: 'status', label: 'Status', kind: 'enum', options: TDS_STATUS, tdsDefault: true },
  { key: 'priority', label: 'Priority', kind: 'enum', options: TDS_PRIORITY, tdsDefault: true },
  {
    key: 'category',
    label: 'Category',
    kind: 'enum',
    options: [...TDS_CATEGORY, ...MAATER_CATEGORY_EXTRA],
    tdsDefault: true,
  },
  { key: 'complexity', label: 'Complexity', kind: 'enum', options: TDS_COMPLEXITY, tdsDefault: true },
  { key: 'estimated_time', label: 'Est. time', kind: 'text', tdsDefault: true },
  { key: 'blockers', label: 'Blockers', kind: 'text', tdsDefault: true },
  { key: 'tags', label: 'Tags', kind: 'tags', tdsDefault: true },
  { key: 'related_todos', label: 'Related todos', kind: 'text', tdsDefault: true },
  { key: 'working_branch', label: 'Branch', kind: 'text' },
  { key: 'git_mr_url', label: 'MR', kind: 'text' },
  { key: 'reviewed_by', label: 'Reviewed by', kind: 'text' },
]

export function noteFieldDef(key: string): NoteFieldDef | undefined {
  return NOTE_FIELD_CATALOG.find((f) => f.key === key)
}

export function addableNoteFields(present: Iterable<string>): NoteFieldDef[] {
  const have = new Set([...present].map((k) => (k === 'blocker' ? 'blockers' : k)))
  return NOTE_FIELD_CATALOG.filter((f) => !have.has(f.key))
}
